import {delegateEvent} from "../utils/event.delegator";
import NavBarView from 'js/views/navbar.view';
import MessageView from 'js/views/message.view';
import PromosView from 'js/views/promos.view';
import {Backbone} from "backboneAdapter";

require('l10n');

export default Backbone.Router.extend({
    routes: {
        ":id": "idRoute",
        "": "defaultRoute"
    },
    initialize: function ({isPostPaid}) {
        console.info("Initializing Message Router");
        this.navbar = new NavBarView();
        this.isPostPaid = isPostPaid;
    },
    idRoute: function (id) {
        console.info("idRoute");
        this.removeAllEvents(this.promosView);
        this.messageView = new MessageView();
        this.messageView.off("changed:campaignStatus");
        delegateEvent(this.navbar, this.messageView, "changed:campaignStatus");
        delegateEvent(this.navbar, this.messageView, "spamResult");
        this.messageView.load(id);
    },
    defaultRoute: function () {
        console.info("defaultRoute");

        this.removeAllEvents(this.messageView);
        this.promosView = new PromosView({"displayButtons": true, postpaid: this.isPostPaid});
    },
    removeAllEvents: function (view) {
        if (view) {
            view.$el.off();
            view.$el.empty();
            view.undelegateEvents();
            view = null;
        }
    }
});
